import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { syncFullscreenState } from "./State/actions";
import { addFullscreenChangeListener } from "./utilities";
import Stage from "./Stage";
import { Settings } from "./settings";

// Primary UI HTML menu components
import GameRulesSection from "./Components/UserInterface/primary/Menu/GameRulesSection";
import SettingsSection from "./Components/UserInterface/primary/Menu/SettingsSection";
import PaytableSection from "./Components/UserInterface/primary/Menu/PaytableSection";

// Secondary UI HTML overlay components
import GameRulesOverlay from "./Components/UserInterface/secondary/Menu/GameRulesOverlay";
import PaytableOverlay from "./Components/UserInterface/secondary/Menu/PaytableOverlay";
import ReplayOverlay from "./Components/UserInterface/secondary/Menu/ReplayOverlay";

const isPrimaryTheme = Settings.APP.UI_THEME === "primary";
const isSecondaryTheme = Settings.APP.UI_THEME === "secondary";

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const cleanup = addFullscreenChangeListener(() => {
      dispatch(syncFullscreenState());
    });

    return cleanup;
  }, [dispatch]);

  return (
    <>
      <Stage />
      {isPrimaryTheme && <GameRulesSection />}
      {isPrimaryTheme && <SettingsSection />}
      {isPrimaryTheme && <PaytableSection />}
      {isSecondaryTheme && <GameRulesOverlay />}
      {isSecondaryTheme && <PaytableOverlay />}
      {isSecondaryTheme && <ReplayOverlay />}
    </>
  );
};

export default App;
